// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import StarGray from '../_raw/ui/icon_star_outline.svg';

export default withIconProps(StarGray);
